module.exports = __webpack_public_path__ + "img/Under-Construction-en.fb64a58.png";